import { Provider } from '@angular/core';
import { DetailVesselActivityUseCase } from '@app/application/use-cases/vessel-activity';
import { VesselActivityRepository } from '@app/domain/repositories/vessel-activity.repository';
import { VesselActivityRepositoryImpl } from '../repositories/vessel-activity.repository.impl';

export const VESSEL_ACTIVITY_PROVIDERS: Provider[] = [
  {
    provide: VesselActivityRepository,
    useClass: VesselActivityRepositoryImpl,
  },

  {
    provide: DetailVesselActivityUseCase,
    useFactory: (vesselActivityRepo: VesselActivityRepository) =>
      new DetailVesselActivityUseCase(vesselActivityRepo),
    deps: [VesselActivityRepository],
  },
];
